import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

/**
 * Handles the node type of the button, depending
 */

function useButtonType(value) {
  var _React$useState = React.useState(!value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isButton = _React$useState2[0],
      setIsButton = _React$useState2[1];

  var refCallback = React.useCallback(function (node) {
    if (!node) return;
    setIsButton(node.tagName === 'BUTTON');
  }, []);
  var type = isButton ? 'button' : undefined;
  return {
    ref: refCallback,
    type: type
  };
}

export { useButtonType };
//# sourceMappingURL=useButtonType.js.map
